import { z } from "zod";

export const changelogEntrySchema = z.object({
  titleKo: z.string().min(1, "한국어 제목을 입력해주세요").max(200),
  titleEn: z.string().max(200).optional().default(""),
  bodyKo: z.string().min(1, "한국어 본문을 입력해주세요"),
  bodyEn: z.string().optional().default(""),
  featuredImageUrl: z.string().optional().default(""),
  categoryIds: z.array(z.string()).min(1, "카테고리를 1개 이상 선택해주세요"),
});

export type ChangelogEntryFormValues = z.infer<typeof changelogEntrySchema>;

export interface BilingualValidationResult {
  valid: boolean;
  missingFields: string[];
}

export function validateBilingualContent(content: {
  titleKo?: string;
  titleEn?: string | null;
  bodyKo?: string;
  bodyEn?: string | null;
}): BilingualValidationResult {
  const missingFields: string[] = [];

  if (!content.titleKo?.trim()) missingFields.push("한국어 제목");
  if (!content.bodyKo?.trim()) missingFields.push("한국어 본문");
  if (!content.titleEn?.trim()) missingFields.push("영문 제목");
  if (!content.bodyEn?.trim()) missingFields.push("영문 본문");

  return { valid: missingFields.length === 0, missingFields };
}
